if (!process.env.REACT_APP_COGNITO_AUTHORITY) {
  console.warn("⚠️  REACT_APP_COGNITO_AUTHORITY is not set.");
}
if (!process.env.REACT_APP_COGNITO_CLIENT_ID) {
  console.warn("⚠️  REACT_APP_COGNITO_CLIENT_ID is not set.");
}
if (!process.env.REACT_APP_COGNITO_REDIRECT_URI) {
  console.warn("⚠️  REACT_APP_COGNITO_REDIRECT_URI is not set.");
}

export const authConfig = {
  // Cognito User Pool issuer URL
  authority: process.env.REACT_APP_COGNITO_AUTHORITY || "",

  // Cognito App Client ID
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID || "",

  // Cognito App Client Secret (only required if your App Client has a secret)
  ...(process.env.REACT_APP_COGNITO_CLIENT_SECRET && {
    client_secret: process.env.REACT_APP_COGNITO_CLIENT_SECRET,
  }),

  // ⚠️ Must also be added to Cognito App Client → Allowed callback URLs
  redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI || window.location.origin + "/login",

  response_type: "code",
  scope: "openid email", // ⚠️ Only add 'phone'/'offline_access' if enabled in Cognito App Client

  // Cognito requires this to fully log out via hosted UI
  metadataSeed: {
    end_session_endpoint: process.env.REACT_APP_COGNITO_LOGOUT_ENDPOINT || "",
  },

  // Automatically refresh tokens silently in the background
  automaticSilentRenew: true,

  // Load user info from the /userinfo endpoint after login
  loadUserInfo: true,

  userStore: new (require("oidc-client-ts").WebStorageStateStore)({
    store: window.localStorage,
  }),
};
